module.exports = __webpack_public_path__ + "static/img/wx.8270f5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wx.jpg
// module id = 9Lcx
// module chunks = 6